import Header from "./Header";

import "./Header.scss";

export default Header;